module.exports = __webpack_public_path__ + "static/media/RELIANCE_F1.cb2f3dc4.txt";